<script lang="ts">
	import { onMount } from 'svelte';

	let visible = $state(false);
	let ticking = false;

	onMount(() => {
		const updateVisibility = () => {
			visible = window.scrollY > 500;
			ticking = false;
		};

		const handleScroll = () => {
			if (!ticking) {
				requestAnimationFrame(updateVisibility);
				ticking = true;
			}
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => window.removeEventListener('scroll', handleScroll);
	});

	function scrollToTop() {
		const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
			? 'auto'
			: 'smooth';
		window.scrollTo({ top: 0, behavior });
	}
</script>

<button
	onclick={scrollToTop}
	class="fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full glass-strong flex items-center justify-center text-slate-400 hover:text-ameta-green hover:border-ameta-green/30 transition-all duration-300 {visible
		? 'opacity-100 translate-y-0'
		: 'opacity-0 translate-y-4 pointer-events-none'}"
	aria-label="Back to top"
>
	<svg aria-hidden="true" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
	</svg>
</button>
